import { TDirectory } from './../index';
import { Reveal } from '..';

export const sortDataOut = (data: any, filter: any, revealFunctionName?: TDirectory) =>
  Reveal(data[Object.keys(data)[0]], filter, revealFunctionName);
